export default __webpack_public_path__ + "static/media/phone.22e8098e.svg";